import { Controller } from '@hotwired/stimulus'

/*
 * This controller allows for dynamic select-all checkboxes.
 * Each select-all checkbox element should be made a "selectall" target
 * and trigger the toggleAll action (data-action="input->checkbox#toggleAll").
 * Each individual checkbox that should be toggled during the toggleAll action should be made an
 * "input" target and trigger the updateSelectAll action (data-action="input->checkbox#updateSelectAll").
 *
 * For more specificity, select-all checkboxes can be tied to a group:
 * If the select-all checkbox has a "data-group" attribute when it triggers the toggleAll action,
 * only input targets with the same "data-group" value will be affected.
 */
export default class extends Controller {
  static targets = ['input', 'selectall']

  toggleAll(event) {
    this.inputTargets.forEach(checkbox => {
      // skip if the checkbox is disabled
      if (checkbox.disabled) return

      // Change the value of the checkbox ONLY if the select-all checkbox is not tied to a group,
      // OR if the select-all checkbox's group matches the current checkbox's group
      if (
        event.target.hasAttribute('data-group')
        && checkbox.getAttribute('data-group') === event.target.getAttribute('data-group')
        || !event.target.hasAttribute('data-group')
      ) {
        checkbox.checked = event.target.checked
      }
    })

    this.updateSelectAll(event)
  }

  updateSelectAll() {
    // Object where key will correspond to a checkbox group (or 'none' for ungrouped checkboxes)
    // and the value is whethor or not all checkboxes in the group are currently checked
    const selected = {}

    // Populate the selected object
    this.inputTargets.forEach(checkbox => {
      const key = checkbox.getAttribute('data-group') || 'none'
      const current = selected[key] === undefined ? true : selected[key]

      selected[key] = current && checkbox.checked
    })

    // Whether or not ALL checkboxes are checked
    const allSelected = Object.values(selected).every(v => v)

    // Update select-all checkboxes to reflect current values
    this.selectallTargets.forEach(checkbox => {
      if (checkbox.hasAttribute('data-group')) {
        checkbox.checked = selected[checkbox.getAttribute('data-group')]
      } else {
        checkbox.checked = allSelected
      }
    })
  }

}
